"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createSessionStorageKey = void 0;
var _sessionStorageKeyPrefix = require("../constants/sessionStorageKeyPrefix");
/** Create session storage key prefix for personal menu */
const createSessionStorageKey = parts => [_sessionStorageKeyPrefix.SESSION_STORAGE_KEY_PREFIX, ...parts.filter(value => value !== undefined)].join('-');
exports.createSessionStorageKey = createSessionStorageKey;